'use client';

import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormSection from './FormSection';
import FormField from './FormField';
import TextareaInput from './TextareaInput';
import type { RSVPFormData } from './RSVPPageClient';

export default function Section9TravelSummary() {
  const { register } = useFormContext<RSVPFormData>();

  return (
    <FormSection
      number={9}
      title="Your Travel Summary"
      description="Give us a quick overview of your expected journey."
    >
      <FormField label="Please briefly tell us your expected travel plan.">
        <TextareaInput
          placeholder="Example: Arriving Bhopal on 30 Dec → Engagement → staying in Bhopal → travelling to Warud on 3 Jan → Wedding → Nagpur Airport on 4 Jan."
          style={{ minHeight: '120px' }}
          registerProps={register('travelSummary')}
        />
      </FormField>
    </FormSection>
  );
}